import { render, staticRenderFns } from "./PropertyInfo.vue?vue&type=template&id=459789a4&scoped=true&"
import script from "./PropertyInfo.vue?vue&type=script&lang=js&"
export * from "./PropertyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459789a4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VSpacer,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459789a4')) {
      api.createRecord('459789a4', component.options)
    } else {
      api.reload('459789a4', component.options)
    }
    module.hot.accept("./PropertyInfo.vue?vue&type=template&id=459789a4&scoped=true&", function () {
      api.rerender('459789a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/PropertyInfo.vue"
export default component.exports